import { useCallback, useEffect, useRef, useState } from "react";
import { CallApiGetSepayEvents } from "../Api/Enforcement";
import { initialPaging } from "../Constants/paging";
import {
  TOP_UP_ACTIONS,
  TOP_UP_METHODS,
  TOP_UP_STATUSES,
} from "../Constants/topUp";

const PAGE_SIZE = 30;

const extractCharacterName = (content) => {
  if (!content) return "";

  const parts = content.split("SEVQR ");
  if (!parts[1]) return "";

  const raw = parts[1].split(" ")[0] || "";
  const specialCharPattern = /[^a-zA-Z0-9]/;

  if (specialCharPattern.test(raw)) {
    return raw.split(specialCharPattern)[0] || "";
  }

  return raw;
};

const mapSepayEventToTopUp = (event) => ({
  id: event.id,
  CharacterName: extractCharacterName(event.content),
  Method: TOP_UP_METHODS.TRANSFER,
  PaymentCode: event.transaction_id,
  Amount: event.transfer_amount,
  Code: event.code ?? "",
  Status: event.processed
    ? TOP_UP_STATUSES.COMPLETED
    : TOP_UP_STATUSES.PENDING,
  Action: TOP_UP_ACTIONS.APPROVE,
  CreatedDate: event.transaction_date,
});

export const useTopUpPage = () => {
  const [topUps, setTopUps] = useState([]);
  const [paging, setPaging] = useState(initialPaging);
  const pagingRef = useRef(paging);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const initialState = useRef(true);

  useEffect(() => {
    pagingRef.current = paging;
  }, [paging]);

  const getListTopUps = useCallback(
    (pageNum, overrides = {}) => {
      const data = {
        searchText:
          overrides.searchText !== undefined ? overrides.searchText : search,
        fromDate:
          overrides.fromDate !== undefined ? overrides.fromDate : fromDate,
        toDate: overrides.toDate !== undefined ? overrides.toDate : toDate,
        page: pageNum !== undefined ? pageNum : pagingRef.current.pageIndex,
        pageSize: PAGE_SIZE,
      };

      CallApiGetSepayEvents(data, (res) => {
        if (res.Status === "success") {
          var result = res.Response.data;
          setTopUps((result.Items || []).map(mapSepayEventToTopUp));
          setPaging((prev) => ({
            ...prev,
            next: result.Next,
            previous: result.Previous,
            totalPages: result.TotalPagesCount,
            pageIndex: result.PageIndex,
          }));
        }
      });
    },
    [search, fromDate, toDate]
  );

  useEffect(() => {
    if (initialState.current) {
      getListTopUps();
      initialState.current = false;
    }
  }, [getListTopUps]);

  const handleFromDateChange = (value) => {
    setFromDate(value);
    getListTopUps(0, { fromDate: value });
  };

  const handleToDateChange = (value) => {
    setToDate(value);
    getListTopUps(0, { toDate: value });
  };

  return {
    topUps,
    search,
    fromDate,
    toDate,
    paging,
    getListTopUps,
    setSearch,
    handleFromDateChange,
    handleToDateChange,
  };
};
